import { Link } from "react-router-dom";

import Roles from "../../components/AccessControl.jsx/Roles";
import Users from "../../components/AccessControl.jsx/Users";
import RightDocSidebar from "../../components/RightSidebar";
import DocNavigation from "../../components/DocNavigation";

export default function AccessControl() {

    const sidebarGroups = [
        {
            title: "1. Role Management",
            expandable: false,
            items: [{ id: "roles", label: "Role Management" }],
        },
        {
            title: "2. User Management",
            expandable: false,
            items: [{ id: "users", label: "User Management" }],
        },
    ];

    return (
        <div className="flex gap-12">

            {/* MAIN CONTENT */}
            <div className="flex-1 space-y-16">

                {/* HEADER */}
                <section className="bg-white rounded-xl border border-slate-200 p-10">
                    <h1 className="text-2xl font-bold text-slate-900 mb-2">
                        Access Control
                    </h1>

                    <p className="text-md text-slate-600 max-w-3xl">
                        Access Control allows administrators to manage who can access the
                        system, what actions they can perform, and which modules are visible
                        to each user.
                    </p>

                    <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                        <h2 className="text-lg font-semibold mb-3">Overview</h2>
                        <p className="text-slate-600 text-sm">
                            EventFlow follows a role-based access control (RBAC) system where
                            permissions are assigned through roles and users inherit access
                            based on their assigned role and module permissions.
                        </p>
                    </section>
                </section>

                {/* SUB MODULES */}
                <Roles />
                <Users />

                {/* NEXT */}
                {/* <section className="border-t pt-8 mt-12">
                    <p className="text-slate-600">
                        Next, continue to the{" "}
                        <Link
                            to="/docs/no-registers"
                            className="font-medium text-[#C9A24E]"
                        >
                            Business Solutions
                        </Link>{" "}
                        section.
                    </p>
                </section> */}
                
                {/* NEXT */}
                <DocNavigation
                    previous={{
                        title: "Accounting Module",
                        link: "/docs/accounting"
                    }}
                    next={{
                        title: "Eliminate Manual Registers",
                        link: "/docs/no-registers"
                    }}
                />
            </div>

            {/* RIGHT SIDEBAR */}
            <RightDocSidebar groups={sidebarGroups} />
        </div>
    );
}
